import { Stack } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import WizardContent from '../WizardContent/WizardContent';
import PatientInformation from '@src/components/Forms/PatientInformation';
interface IPatientInformationStepProps {
  smartyKey: string;
  setModalType: Dispatch<SetStateAction<'existingConsultation' | 'promptToCall'>>;
}
export default function PatientInformationStep({
  smartyKey,
  setModalType
}: IPatientInformationStepProps) {
  return <WizardContent data-sentry-element="WizardContent" data-sentry-component="PatientInformationStep" data-sentry-source-file="PatientInformationStep.tsx">
			<Stack direction="column" spacing={2.5} data-test-id="section_patient_information_step" data-sentry-element="Stack" data-sentry-source-file="PatientInformationStep.tsx">
				<PatientInformation smartyKey={smartyKey} setModalType={setModalType} data-sentry-element="PatientInformation" data-sentry-source-file="PatientInformationStep.tsx" />
			</Stack>
		</WizardContent>;
}